// extracted by css-extract-rspack-plugin
export default {"trigger":"BCGB_","dropdown":"T_u35","backButton":"eBuTk"};